import styled from "styled-components";
import { primaryColor } from "../../../../config";

export const Wrapper = styled.div`
  .analytics-cards-row {
    .dash-analytics-trend-card {
      border-radius: 0.65rem;
      transition: box-shadow 0.15s ease, border-color 0.15s ease;
    }
    .dash-analytics-trend-card:hover {
      border-color: #e4e6ef !important;
      box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.04);
    }
    .dash-analytics-trend-card__spark {
      align-self: stretch;
      display: flex;
      align-items: flex-end;
    }

    /* Total Revenue — chart header + metrics (light / dark tokens) */
    .dash-total-revenue-card {
      --dtr-chart-gradient: linear-gradient(145deg, #ffa1a254 0%, #e246473d 45%, #ffa1a233 100%);
      --dtr-empty-color: rgba(24, 28, 50, 0.55);
      --dtr-value-color: var(--app-text);
      --dtr-muted-color: var(--app-text-muted);
      --dtr-subrow-border: var(--app-border-soft);
      --dtr-subcol-border: var(--app-border);
      --dtr-shadow: 0 0.5rem 1.5rem rgba(24, 28, 50, 0.08);
      border-radius: 0.85rem;
      overflow: hidden;
      box-shadow: var(--dtr-shadow);
      border: 1px solid var(--app-border);
      background: var(--app-surface);
      display: flex;
      flex-direction: column;
    }

    [data-bs-theme="dark"] & .dash-total-revenue-card {
      --dtr-chart-gradient: linear-gradient(
        145deg,
        rgba(244, 91, 104, 0.35) 0%,
        rgba(244, 91, 104, 0.14) 45%,
        rgba(30, 30, 45, 0.95) 100%
      );
      --dtr-empty-color: var(--app-text-muted);
      --dtr-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.25);
    }

    .dash-total-revenue-card__chart-panel {
      background: var(--dtr-chart-gradient);
      padding: 0 1rem 0.75rem;
      flex-shrink: 0;
    }

    .dash-total-revenue-card__chart-head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 1.25rem 0.35rem 0.5rem;
    }

    .dash-total-revenue-card__title {
      color: var(--app-text);
      font-weight: 800;
      font-size: 1.15rem;
      letter-spacing: -0.02em;
      line-height: 1.2;
    }

    .dash-total-revenue-card__icon {
      color: var(--app-text) !important;
      font-size: 1.25rem;
      opacity: 0.85;
    }

    .dash-total-revenue-card__chart-body {
      min-height: 50px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }

    .dash-total-revenue-card__svg {
      display: block;
    }

    .dash-total-revenue-card__empty {
      width: 100%;
      color: var(--dtr-empty-color);
      opacity: 0.95;
    }

    .dash-total-revenue-card__body {
      background: var(--app-surface);
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .dash-total-revenue-card__primary {
      padding: 1.25rem 1.25rem 1rem;
    }

    .dash-total-revenue-card__primary-value {
      font-size: 1.75rem;
      font-weight: 800;
      color: var(--dtr-value-color);
      line-height: 1.15;
      letter-spacing: -0.02em;
    }

    .dash-total-revenue-card__trend {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      gap: 0.35rem 0.5rem;
      margin-top: 0.5rem;
      font-weight: 700;
      font-size: 0.95rem;
      color: var(--dtr-value-color);
    }

    .dash-total-revenue-card__trend--up {
      color: #50cd89;
    }

    .dash-total-revenue-card__trend--down {
      color: #f1416c;
    }

    .dash-total-revenue-card__trend--muted {
      color: var(--dtr-muted-color);
    }

    .dash-total-revenue-card__trend-delta {
      font-weight: 600;
      color: var(--dtr-value-color);
    }

    .dash-total-revenue-card__trend-pct {
      font-weight: 600;
    }

    .dash-total-revenue-card__trend-pct .text-muted {
      color: var(--dtr-muted-color) !important;
    }

    .dash-total-revenue-card__subrow {
      display: flex;
      align-items: stretch;
      border-top: 1px solid var(--dtr-subrow-border);
      margin-top: auto;
    }

    .dash-total-revenue-card__subcol {
      flex: 1;
      min-width: 0;
      padding: 1rem 0.65rem 1.1rem;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 0.25rem;
    }

    .dash-total-revenue-card__subcol--dotted {
      border-left: 1px dotted var(--dtr-subcol-border);
    }

    .dash-total-revenue-card__subcol--solid {
      border-left: 1px solid var(--dtr-subcol-border);
    }

    .dash-total-revenue-card__subvalue {
      font-size: 16px;
      font-weight: 800;
      color: var(--dtr-value-color);
      line-height: 1.2;
      letter-spacing: -0.02em;
    }

    .dash-total-revenue-card__sublabel {
      font-size: 0.96rem;
      font-weight: 600;
      color: var(--dtr-muted-color);
      text-transform: none;
    }
  }

  /* Second KPI strip: orders, ad sales, refund, ad CVR — no charts */
  .analytics-cards-revenue {
    --acr-radius: 0.75rem;
    --acr-border: var(--app-border);
    --acr-muted: var(--app-text-muted);
    --acr-hint: var(--app-text-muted);
    --acr-trend-pill-bg: #f5f8fa;
    --acr-chip-text: var(--app-text);
    --acr-hover-border: #e4e6ef;
    --acr-hover-shadow: 0 0.35rem 1.25rem rgba(24, 28, 50, 0.06);
    --acr-remove-hover-bg: #fff5f8;
  }

  [data-bs-theme="dark"] & .analytics-cards-revenue {
    --acr-trend-pill-bg: #2b2b40;
    --acr-hover-border: #3f4254;
    --acr-hover-shadow: 0 0.35rem 1.25rem rgba(0, 0, 0, 0.22);
    --acr-remove-hover-bg: rgba(244, 91, 104, 0.2);
  }

  .analytics-cards-revenue .acr-card {
    position: relative;
    height: 100%;
    border-radius: var(--acr-radius);
    border: 1px solid var(--acr-border);
    background: var(--app-surface);
    // box-shadow: 0 1px 2px rgba(24, 28, 50, 0.04);
    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
  }

  .analytics-cards-revenue .acr-card__remove {
    position: absolute;
    top: 0.4rem;
    right: 0.4rem;
    z-index: 2;
    width: 1.35rem;
    height: 1.35rem;
    border: none;
    border-radius: 50%;
    background: var(--app-surface);
    color: #a1a5b7;
    font-size: 1.3rem;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: color 0.15s ease, background 0.15s ease;
  }

  .analytics-cards-revenue .acr-card__remove:hover {
    color: #f1416c;
    background: var(--acr-remove-hover-bg);
  }

  .analytics-cards-revenue .acr-card:hover {
    border-color: var(--acr-hover-border);
    box-shadow: var(--acr-hover-shadow);
    transform: translateY(-1px);
  }

  .analytics-cards-revenue .acr-card__inner {
    display: flex;
    min-height: 100%;
    border-radius: inherit;
    overflow: hidden;
  }

  .analytics-cards-revenue .acr-card__accent {
    width: 2px;
    flex-shrink: 0;
    border-radius: var(--acr-radius) 0 0 var(--acr-radius);
  }

  .analytics-cards-revenue .acr-card--slate .acr-card__accent {
    background: linear-gradient(180deg, #5e6278 0%, #3f4254 100%);
  }
  .analytics-cards-revenue .acr-card--blue .acr-card__accent {
    background: linear-gradient(180deg, #009ef7 0%, #0b5ed7 100%);
  }
  .analytics-cards-revenue .acr-card--rose .acr-card__accent {
    background: linear-gradient(180deg, #f1416c 0%, #d9214e 100%);
  }
  .analytics-cards-revenue .acr-card--teal .acr-card__accent {
    background: linear-gradient(180deg, #50cd89 0%, #2ea66b 100%);
  }
  .analytics-cards-revenue .acr-card--violet .acr-card__accent {
    background: linear-gradient(180deg, #7239ea 0%, #5014d0 100%);
  }
  .analytics-cards-revenue .acr-card--amber .acr-card__accent {
    background: linear-gradient(180deg, #ffc700 0%, #f1bc00 100%);
  }
  .analytics-cards-revenue .acr-card--coral .acr-card__accent {
    background: linear-gradient(180deg, #fd7e14 0%, #e8590c 100%);
  }
  .analytics-cards-revenue .acr-card--indigo .acr-card__accent {
    background: linear-gradient(180deg, #6610f2 0%, #520dc2 100%);
  }

  .analytics-cards-revenue .acr-card--slate {
    background: linear-gradient(135deg, #fcfcfd 0%, #ffffff 55%);
  }
  .analytics-cards-revenue .acr-card--blue {
    background: linear-gradient(135deg, #f6fbff 0%, #ffffff 60%);
  }
  .analytics-cards-revenue .acr-card--rose {
    background: linear-gradient(135deg, #fffafb 0%, #ffffff 60%);
  }
  .analytics-cards-revenue .acr-card--teal {
    background: linear-gradient(135deg, #f6fff9 0%, #ffffff 60%);
  }
  .analytics-cards-revenue .acr-card--violet {
    background: linear-gradient(135deg, #f8f5ff 0%, #ffffff 60%);
  }
  .analytics-cards-revenue .acr-card--amber {
    background: linear-gradient(135deg, #fffdf5 0%, #ffffff 60%);
  }
  .analytics-cards-revenue .acr-card--coral {
    background: linear-gradient(135deg, #fff8f3 0%, #ffffff 60%);
  }
  .analytics-cards-revenue .acr-card--indigo {
    background: linear-gradient(135deg, #f5f3ff 0%, #ffffff 60%);
  }

  .analytics-cards-revenue .acr-card__body {
    flex: 1;
    padding: 1.1rem 1.15rem 1.15rem 1rem;
    min-width: 0;
  }

  .analytics-cards-revenue .acr-card__label {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--acr-muted);
    margin-bottom: 0.35rem;
  }

  .analytics-cards-revenue .acr-card__value {
    font-size: 1.35rem;
    font-weight: 800;
    line-height: 1.15;
    color: var(--app-text);
    letter-spacing: -0.02em;
    margin-bottom: 0.25rem;
  }

  .analytics-cards-revenue .acr-card__hint {
    font-size: 0.8125rem;
    font-weight: 600;
    color: var(--acr-hint);
    margin-bottom: 0.65rem;
  }

  .analytics-cards-revenue .acr-card__trend {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.35rem 0.5rem;
    margin-top: 0.15rem;
  }
  @media (max-width: 767.98px) {
    .analytics-cards-revenue .acr-card__trend {
      gap: 0.35rem 0.5rem;
      flex-direction: column;
      justify-content: flex-start;
      align-items: baseline;
  }
  }


  @media (max-width: 767.98px) {
   .side-bar-card {
        margin-top: 0px;
        padding-bottom: 0 !important;
        align-self: auto;
    }
    .pl-sidebar {
        border-radius: 0.75rem;
        background: var(--app-surface);
        display: flex;
        flex-direction: column;
        min-height: 0;
        position: static;
        top: 40px;
        height: auto !important;
        max-height: none;
    }
  }

  .side-bar-card {
    align-self: flex-start;
    position: sticky;
    top: 50px;
  }

  .analytics-cards-revenue .acr-card__trend-pill {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.35rem;
    padding: 0.2rem 0.55rem;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 700;
    background: var(--acr-trend-pill-bg);
    border: 1px solid var(--app-border);
  }

  .analytics-cards-revenue .acr-card__trend--good .acr-card__trend-pill {
    background: #e8fff3;
    border-color: #c5f0d8;
    color: #0f5132;
  }
  .analytics-cards-revenue .acr-card__trend--bad .acr-card__trend-pill {
    background: #fff5f8;
    border-color: #f5c2c7;
    color: #842029;
  }
  .analytics-cards-revenue .acr-card__trend--neutral .acr-card__trend-pill {
    color: var(--acr-hint);
  }

  [data-bs-theme="dark"] & .analytics-cards-revenue .acr-card__trend--good .acr-card__trend-pill {
    background: rgba(80, 205, 137, 0.14);
    border-color: rgba(80, 205, 137, 0.35);
    color: #5dd39e;
  }

  [data-bs-theme="dark"] & .analytics-cards-revenue .acr-card__trend--bad .acr-card__trend-pill {
    background: rgba(241, 65, 108, 0.14);
    border-color: rgba(241, 65, 108, 0.35);
    color: #ff8a94;
  }

  .analytics-cards-revenue .acr-card__trend-delta {
    font-weight: 800;
    opacity: 0.95;
  }

  .analytics-cards-revenue .acr-card__trend-pct {
    font-weight: 800;
  }

  .analytics-cards-revenue .acr-card__trend-note {
    font-size: 0.65rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--acr-muted);
  }

  .analytics-cards-revenue .acr-card--picker .acr-card__accent {
    background: linear-gradient(180deg, #3f4254 0%, #181c32 100%);
  }

  .analytics-cards-revenue .acr-card--picker {
    background: linear-gradient(135deg, #f9f9f9 0%, #ffffff 60%);
  }

  [data-bs-theme="dark"] & .analytics-cards-revenue .acr-card--slate {
    background: linear-gradient(135deg, rgba(94, 98, 120, 0.22) 0%, var(--app-surface) 55%);
  }
  [data-bs-theme="dark"] & .analytics-cards-revenue .acr-card--blue {
    background: linear-gradient(135deg, rgba(0, 158, 247, 0.16) 0%, var(--app-surface) 55%);
  }
  [data-bs-theme="dark"] & .analytics-cards-revenue .acr-card--rose {
    background: linear-gradient(135deg, rgba(241, 65, 108, 0.14) 0%, var(--app-surface) 55%);
  }
  [data-bs-theme="dark"] & .analytics-cards-revenue .acr-card--teal {
    background: linear-gradient(135deg, rgba(80, 205, 137, 0.14) 0%, var(--app-surface) 55%);
  }
  [data-bs-theme="dark"] & .analytics-cards-revenue .acr-card--violet {
    background: linear-gradient(135deg, rgba(114, 57, 234, 0.16) 0%, var(--app-surface) 55%);
  }
  [data-bs-theme="dark"] & .analytics-cards-revenue .acr-card--amber {
    background: linear-gradient(135deg, rgba(255, 199, 0, 0.12) 0%, var(--app-surface) 55%);
  }
  [data-bs-theme="dark"] & .analytics-cards-revenue .acr-card--coral {
    background: linear-gradient(135deg, rgba(253, 126, 20, 0.14) 0%, var(--app-surface) 55%);
  }
  [data-bs-theme="dark"] & .analytics-cards-revenue .acr-card--indigo {
    background: linear-gradient(135deg, rgba(102, 16, 242, 0.16) 0%, var(--app-surface) 55%);
  }
  [data-bs-theme="dark"] & .analytics-cards-revenue .acr-card--picker {
    background: linear-gradient(135deg, #2b2b40 0%, var(--app-surface) 60%);
  }

  .analytics-cards-revenue .acr-picker__title {
    font-size: 1.2rem;
    font-weight: 800;
    color: var(--app-text);
    margin-bottom: 0.15rem;
  }

  @media (max-width: 991.98px) {
    .analytics-cards-revenue .acr-picker__title {
      font-size: 11px;
    }
    .metrics-picker__add {
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;
    }
  }

  .analytics-cards-revenue .acr-picker__hint {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--acr-muted);
    margin: 0;
  }

  .analytics-cards-revenue .acr-picker__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
  }

  .analytics-cards-revenue .acr-picker__chip {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.2rem 0.45rem 0.2rem 0.55rem;
    border-radius: 999px;
    background: var(--app-surface-alt);
    border: 1px solid var(--app-border);
    font-size: 0.72rem;
    font-weight: 700;
    color: var(--app-text);
  }

  .analytics-cards-revenue .acr-picker__chip-remove {
    border: none;
    background: transparent;
    color: var(--app-text-muted);
    font-size: 1rem;
    line-height: 1;
    padding: 0 0.15rem;
    cursor: pointer;
  }

  .analytics-cards-revenue .acr-picker__chip-remove:hover {
    color: #f1416c;
  }
  .analytics-cards-revenue .acr-picker__select .ant-select-selector {
    background: var(--app-surface) !important;
    border: 1px solid var(--app-border) !important;
    min-height: 32px;
    font-size: 0.95rem;
    font-weight: 700;
    color: var(--app-text);
    box-shadow: none !important;
    padding: 0 12px !important;
    transition: border-color 0.2s;
  }

  [data-bs-theme="dark"] & .analytics-cards-revenue .ant-select-outlined.ant-select-multiple .ant-select-selection-item {
    background: rgba(255, 255, 255, 0.08);
    color: var(--app-text);
  }

  .analytics-cards-revenue .acr-picker__select .ant-select-focused .ant-select-selector,
  .analytics-cards-revenue .acr-picker__select .ant-select-selector:focus,
  .analytics-cards-revenue .acr-picker__select .ant-select-selector:hover {
    border-color: #f1416c40 !important;
  }

  .analytics-cards-revenue .acr-picker__select .ant-select-arrow {
    color: #f1416c;
    font-size: 1rem;
    right: 12px;
  }
  .analytics-cards-revenue .ant-select-outlined.ant-select-multiple .ant-select-selection-item {
      background: rgba(0, 0, 0, 0.06);
      border: 1px solid transparent;
      font-size: 10px;
      font-weight: 600;
      height: 24px;
  }
  .analytics-cards-revenue .ant-select-selection-item-content {
      line-height: 2;
  }

  .metrics-picker-dropdown.ant-dropdown .ant-dropdown-menu {
    padding: 0;
    background: transparent;
    box-shadow: none;
  }

  .metrics-picker-menu {
    min-width: 280px;
    max-width: 340px;
    background: var(--app-surface);
    border-radius: 0.5rem;
    border: 1px solid var(--app-border);
    box-shadow: 0 4px 20px rgba(24, 28, 50, 0.12);
    overflow: hidden;
  }

  [data-bs-theme="dark"] & .metrics-picker-menu {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);
  }

  .metrics-picker-menu__head {
    padding: 0.75rem 1rem 0.75rem;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    color: var(--app-text-muted);
    border-bottom: 1px dashed var(--app-border);
  }

  .metrics-picker-menu__list {
    max-height: 320px;
    overflow-y: auto;
    padding: 0.35rem 0;
  }

  .metrics-picker-menu__item {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0.4rem 0.5rem;
    width: 100%;
    padding: 0.6rem 1rem;
    border: none;
    background: transparent;
    text-align: left;
    cursor: pointer;
    transition: background 0.12s ease;
  }

  .metrics-picker-menu__item:hover {
    background: var(--app-surface-alt);
  }

  .metrics-picker-menu__item-name {
    font-size: 0.87rem;
    font-weight: 800;
    color: var(--app-text);
    letter-spacing: 0.02em;
    white-space: nowrap;
  }

  .metrics-picker-menu__item-hint {
    font-size: 0.8125rem;
    font-weight: 500;
    color: var(--app-text-muted);
    white-space: nowrap;
  }

  .metrics-picker-menu__empty {
    padding: 1rem;
    font-size: 0.8125rem;
    font-weight: 600;
    color: var(--app-text-muted);
    text-align: center;
  }

  .metrics-picker__add {
    width: 52px;
    height: 52px;
    min-width: 52px;
    min-height: 52px;
    border-color: var(--app-border) !important;
    color: var(--app-text) !important;
    background: var(--app-surface-alt) !important;
  }

  .metrics-picker__add:hover:not(:disabled) {
    border-color: #f45b68 !important;
    color: #f45b68 !important;
    background: var(--app-surface) !important;
  }

  .chart-card {
    min-height: 320px;
  }

  .dash-units-net-chart-card {
    --dunc-bg: var(--app-surface);
    --dunc-border: var(--app-border);
    --dunc-title: var(--app-text);
    --dunc-muted: var(--app-text-muted);
    --dunc-legend: var(--app-text-muted);
    --dunc-footer-border: var(--app-border);
    --dunc-ft-label: var(--app-text-muted);
    --dunc-ft-value: var(--app-text);
    --dunc-ft-blue: #1b84ff;
    --dunc-ft-profit: #f45b68;
    --dunc-empty: var(--app-text-muted);
    --dunc-legend-net-fill: rgba(244, 91, 104, 0.08);
    --dunc-legend-net-border: #f45b68;
    --dunc-legend-units: #314f71;
    border-radius: 0.65rem;
    min-height: 380px;
    background: var(--dunc-bg);
    border-color: var(--dunc-border) !important;
  }

  [data-bs-theme="dark"] & .dash-units-net-chart-card {
    --dunc-ft-blue: #6ea8fe;
    --dunc-legend-net-fill: rgba(244, 91, 104, 0.22);
    --dunc-legend-units: #6ea8fe;
    box-shadow: 0 0.35rem 1.25rem rgba(0, 0, 0, 0.18);
  }

  .dash-units-net-chart-card__title {
    color: var(--dunc-title) !important;
  }

  .dash-units-net-chart-card__subtitle {
    color: var(--dunc-muted) !important;
  }

  .dash-units-net-chart-card__legend {
    color: var(--dunc-legend) !important;
  }

  .dash-units-net-chart-card__legend-swatch--net {
    width: 10px;
    height: 10px;
    background: var(--dunc-legend-net-fill);
    border: 1px solid var(--dunc-legend-net-border);
  }

  .dash-units-net-chart-card__legend-swatch--units {
    width: 18px;
    height: 3px;
    background: var(--dunc-legend-units);
  }

  .dash-units-net-chart-card__canvas {
    min-height: 280px;
  }

  .dash-units-net-chart-card__empty {
    color: var(--dunc-empty) !important;
  }

  .dash-units-net-chart-card__footer {
    border-color: var(--dunc-footer-border) !important;
  }

  .dash-units-net-chart-card__ft-label {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    color: var(--dunc-ft-label);
    text-transform: uppercase;
    margin-bottom: 0.25rem;
  }

  .dash-units-net-chart-card__ft-value {
    font-size: 1.1rem;
    font-weight: 800;
    color: var(--dunc-ft-value);
    line-height: 1.2;
  }

  .dash-units-net-chart-card__ft-value--blue {
    color: var(--dunc-ft-blue);
  }

  .dash-units-net-chart-card__ft-value--profit {
    color: var(--dunc-ft-profit);
  }

  .dash-units-net-chart-card__ft-value--green {
    color: #50cd89;
  }

  [data-bs-theme="dark"] & .dash-units-net-chart-card__ft-value--green {
    color: #6ee7a8;
  }

  .cost-breakdown-card {
    --cbd-text: var(--app-text);
    --cbd-text-muted: var(--app-text-muted);
    --cbd-border: var(--app-border);
    --cbd-track-bg: #f1f1f4;
    --cbd-footer-bg: var(--app-surface-alt);
    border-radius: 0.65rem;
    min-height: 320px;
    background: var(--app-surface);
    border-color: var(--app-border) !important;
  }

  [data-bs-theme="dark"] & .cost-breakdown-card {
    --cbd-track-bg: #2b2b40;
    --cbd-footer-bg: #252536;
    box-shadow: 0 0.35rem 1.25rem rgba(0, 0, 0, 0.18);
  }

  .cost-breakdown-card__title {
    color: var(--cbd-text);
  }

  .cost-breakdown-card__label,
  .cost-breakdown-card__amount {
    color: var(--cbd-text);
  }

  .cost-breakdown-card__row--divider {
    border-top: 1px dashed var(--cbd-border) !important;
  }

  .cost-breakdown-card__swatch {
    width: 10px;
    height: 10px;
  }

  .cost-breakdown-card__track {
    height: 4px;
    background: var(--cbd-track-bg);
  }

  .cost-breakdown-card__bar {
    height: 4px;
    min-width: 0;
    transition: width 0.35s ease;
  }

  .cost-breakdown-card__compare {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.25rem;
    margin-top: 0.15rem;
    font-size: 0.72rem;
    font-weight: 600;
    color: var(--cbd-text-muted);
    white-space: nowrap;
  }

  .cost-breakdown-card__compare-pct {
    color: var(--cbd-text-muted);
  }

  .cost-breakdown-card__compare-pct--up {
    color: #f1416c;
  }

  .cost-breakdown-card__compare-pct--down {
    color: #50cd89;
  }

  [data-bs-theme="dark"] & .cost-breakdown-card__compare-pct--up {
    color: #ff8a94;
  }

  [data-bs-theme="dark"] & .cost-breakdown-card__compare-pct--down {
    color: #5dd39e;
  }

  .cost-breakdown-card__footer {
    background: var(--cbd-footer-bg);
    border-top: 1px dashed var(--cbd-border);
  }

  .cost-breakdown-card__footer-label {
    font-size: 0.9rem;
    font-weight: 700;
    color: var(--cbd-text-muted);
    text-transform: uppercase;
  }

  .cost-breakdown-card__footer-value {
    color: var(--cbd-text);
    letter-spacing: -0.02em;
  }

  .pl-sidebar {
    --pl-text: var(--app-text);
    --pl-text-muted: var(--app-text-muted);
    --pl-border: var(--app-border);
    --pl-border-soft: var(--app-border-soft);
    --pl-surface-alt: var(--app-surface-alt);
    --pl-gross-positive-bg: #e8f7f1;
    --pl-gross-positive-border: #b8e6d1;
    --pl-gross-negative-bg: #fef1f0;
    --pl-gross-negative-border: #f5c6cb;
    --pl-compare-muted: #99a1b7;
    --pl-chev: #99a1b7;
    border-radius: 0.75rem;
    background: var(--app-surface);
    border-color: var(--app-border) !important;
    display: flex;
    flex-direction: column;
    min-height: 0;
    max-height: calc(100vh - 70px);
    height: calc(100vh - 70px);
    overflow: hidden;
  }

  [data-bs-theme="dark"] & .pl-sidebar {
    --pl-gross-positive-bg: rgba(80, 205, 137, 0.14);
    --pl-gross-positive-border: rgba(80, 205, 137, 0.35);
    --pl-gross-negative-bg: rgba(241, 65, 108, 0.14);
    --pl-gross-negative-border: rgba(241, 65, 108, 0.35);
    --pl-compare-muted: var(--app-text-muted);
    --pl-chev: var(--app-text-muted);
    box-shadow: 0 0.35rem 1.25rem rgba(0, 0, 0, 0.2);
  }

  .pl-sidebar__head {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 1.15rem 1.15rem 1rem;
    // border-bottom: 1px solid #e4e6ef;
  }

  .pl-sidebar__title {
    margin: 0;
    font-size: 1rem;
    font-weight: 800;
    color: var(--app-text);
  }

  .pl-sidebar__subtitle,
  .pl-sidebar__row-subtitle {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--pl-text-muted);
    line-height: 1.9;
  }

  .pl-sidebar__period {
    font-size: 0.72rem;
    font-weight: 700;
    color: var(--pl-text-muted);
  }

  .pl-sidebar__scroll {
    flex: 1 1 0;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    -webkit-overflow-scrolling: touch;
  }

  .pl-sidebar__rows {
    flex: 1 0 auto;
    min-height: min-content;
    background: var(--app-surface);
  }

  .pl-sidebar__row {
    display: grid;
    grid-template-columns: 0.55rem 0.55rem minmax(0, 1fr) auto;
    gap: 0.45rem;
    align-items: center;
    padding: 0.85rem 1rem;
    border-bottom: 1px solid var(--app-border);
  }

  .pl-sidebar__row--expandable {
    display: block;
    padding: 0;
  }

  .pl-sidebar__details-summary--static {
    cursor: default;
  }

  .pl-sidebar__chev--placeholder {
    visibility: hidden;
  }

  .pl-sidebar__details {
    width: 100%;
  }

  .pl-sidebar__details-summary {
    display: grid;
    grid-template-columns: 0.55rem 0.55rem minmax(0, 1fr) auto;
    gap: 0.8rem;
    align-items: center;
    padding: 0.85rem 1rem;
    list-style: none;
    cursor: pointer;
  }

  .pl-sidebar__details-summary::-webkit-details-marker {
    display: none;
  }

  .pl-sidebar__details[open] .pl-sidebar__chev {
    display: inline-block;
    transform: rotate(90deg);
    transform-origin: 0.35em 0.55em;
  }

  .pl-sidebar__chev {
    color: var(--pl-chev);
    font-size: 1rem;
    line-height: 1;
    transition: transform 0.15s ease;
  }

  .pl-sidebar__children {
    padding: 0 1rem 0.85rem 4rem;
    background: var(--pl-surface-alt);
    border-top: 1px solid var(--pl-border-soft);
  }

  .pl-sidebar__child {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 0.65rem;
    font-size: 0.9rem;
    padding: 0.38rem 0;
    border-bottom: 1px dashed var(--pl-border);
  }

  .pl-sidebar__child:last-child {
    border-bottom: none;
  }

  .pl-sidebar__child-block:last-child .pl-sidebar__child {
    border-bottom: none;
  }

  .pl-sidebar__child--nested {
    font-size: 0.84rem;
    padding: 0.3rem 0;
    border-bottom: none;
  }

  .pl-sidebar__child-nested {
    margin: 0.1rem 0 0.35rem 0.85rem;
    padding-left: 0.65rem;
  }

  .pl-sidebar__child-nested-row {
    display: flex;
    align-items: stretch;
    position: relative;
    padding-left: 0.85rem;
  }

  .pl-sidebar__child-connector {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 0.75rem;
    pointer-events: none;
  }

  .pl-sidebar__child-connector::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 50%;
    width: 0.75rem;
    border-left: 1.5px solid rgba(244, 91, 104, 0.28);
    border-bottom: 1.5px solid rgba(244, 91, 104, 0.28);
    border-bottom-left-radius: 0.35rem;
  }

  .pl-sidebar__child-nested-row:not(.pl-sidebar__child-nested-row--last) .pl-sidebar__child-connector::after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    bottom: -0.2rem;
    border-left: 1.5px solid rgba(244, 91, 104, 0.28);
  }

  .pl-sidebar__child-nested-row .pl-sidebar__child {
    flex: 1;
    min-width: 0;
  }

  .pl-sidebar__child-title {
    color: var(--pl-text-muted);
    font-weight: 600;
    line-height: 1.3;
  }

  .pl-sidebar__child-value {
    font-weight: 700;
    color: var(--pl-text);
    text-align: right;
    white-space: nowrap;
  }

  .pl-sidebar__row--metric .pl-sidebar__dash {
    background: #3699ff;
  }

  .pl-sidebar__row--metric .pl-sidebar__amount {
    color: var(--app-text);
  }

  .pl-sidebar__dash {
    width: 7px;
    height: 2px;
    border-radius: 999px;
    background: #f1416c;
  }

  .pl-sidebar__row--revenue .pl-sidebar__dash,
  .pl-sidebar__row--gross .pl-sidebar__dash {
    background: transparent;
  }

  .pl-sidebar__row--gross {
    grid-template-columns: minmax(0, 1fr) auto;
    padding: 1rem 1.15rem;
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;
  }

  .pl-sidebar__row--gross-positive {
    background: var(--pl-gross-positive-bg);
    border-top-color: var(--pl-gross-positive-border);
    border-bottom-color: var(--pl-gross-positive-border);
  }

  .pl-sidebar__row--gross-negative {
    background: var(--pl-gross-negative-bg);
    border-top-color: var(--pl-gross-negative-border);
    border-bottom-color: var(--pl-gross-negative-border);
  }

  .pl-sidebar__row--gross .pl-sidebar__chev,
  .pl-sidebar__row--gross .pl-sidebar__dash {
    display: none;
  }

  .pl-sidebar__row-title {
    font-size: 1rem;
    font-weight: 700;
    color: var(--pl-text);
    line-height: 1.25;
  }

  .pl-sidebar__row--revenue .pl-sidebar__row-title,
  .pl-sidebar__row--gross .pl-sidebar__row-title {
    color: var(--app-text);
    font-weight: 800;
  }

  .pl-sidebar__row--gross .pl-sidebar__row-title {
    text-transform: uppercase;
    font-size: 0.8rem;
    letter-spacing: 0.04em;
  }

  .pl-sidebar__row--gross-positive .pl-sidebar__row-title {
    color: #16855a;
  }

  .pl-sidebar__row--gross-negative .pl-sidebar__row-title {
    color: #c93b3b;
  }

  [data-bs-theme="dark"] & .pl-sidebar__row--gross-positive .pl-sidebar__row-title {
    color: #5dd39e;
  }

  [data-bs-theme="dark"] & .pl-sidebar__row--gross-negative .pl-sidebar__row-title {
    color: #ff8a94;
  }

  .pl-sidebar__row-amounts {
    text-align: right;
    min-width: 4.75rem;
  }

  .pl-sidebar__amount {
    font-size: 1rem;
    font-weight: 800;
    color: var(--app-text);
    line-height: 1.2;
  }

  .pl-sidebar__row--cost .pl-sidebar__amount {
    color: #f1416c;
  }

  .pl-sidebar__row--gross .pl-sidebar__amount {
    font-size: 1.35rem;
  }

  .pl-sidebar__row--gross-positive .pl-sidebar__amount {
    color: #16855a;
  }

  .pl-sidebar__row--gross-negative .pl-sidebar__amount {
    color: #f1416c;
  }

  [data-bs-theme="dark"] & .pl-sidebar__row--gross-positive .pl-sidebar__amount {
    color: #5dd39e;
  }

  [data-bs-theme="dark"] & .pl-sidebar__row--gross-negative .pl-sidebar__amount {
    color: #ff8a94;
  }

  .pl-sidebar__row--gross-positive .pl-sidebar__margin {
    color: #16855a;
  }

  .pl-sidebar__row--gross-negative .pl-sidebar__margin {
    color: #f1416c;
  }

  [data-bs-theme="dark"] & .pl-sidebar__row--gross-positive .pl-sidebar__margin {
    color: #5dd39e;
  }

  [data-bs-theme="dark"] & .pl-sidebar__row--gross-negative .pl-sidebar__margin {
    color: #ff8a94;
  }

  .pl-sidebar__compare,
  .pl-sidebar__margin {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.2rem;
    margin-top: 0.15rem;
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--pl-compare-muted);
    white-space: nowrap;
  }

  .pl-sidebar__compare-pct {
    margin-left: 8px;
  }

  .pl-sidebar__compare-pct--up {
    color: #50cd89;
  }

  .pl-sidebar__compare-pct--down {
    color: #f1416c;
  }

  [data-bs-theme="dark"] & .pl-sidebar__compare-pct--up {
    color: #5dd39e;
  }

  [data-bs-theme="dark"] & .pl-sidebar__compare-pct--down {
    color: #ff8a94;
  }

  .pl-sidebar__compare-up {
    color: #f1416c;
  }

  .pl-sidebar__compare-down {
    color: #50cd89;
  }

  .pl-sidebar__footer {
    position: sticky;
    bottom: 0;
    z-index: 3;
    flex-shrink: 0;
    margin-top: auto;
  }

  .pl-sidebar__net {
    flex-shrink: 0;
    padding: 1.25rem 1.15rem 1.05rem;
    color: #fff;
    box-shadow: 0 -8px 24px rgba(24, 28, 50, 0.12);
  }

  [data-bs-theme="dark"] & .pl-sidebar__footer .pl-sidebar__net {
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.35);
  }

  .pl-sidebar__net--positive {
    background: linear-gradient(145deg, #158653 0%, #0f8f59 100%);
  }

  .pl-sidebar__net--negative {
    background: linear-gradient(45deg, #f45b68, #d13744);
  }

  .pl-sidebar__net-label {
    font-size: 0.9rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    opacity: 0.85;
  }

  .pl-sidebar__net-subtitle,
  .pl-sidebar__net-margin {
    font-size: 0.8rem;
    font-weight: 600;
    opacity: 0.85;
  }

  .pl-sidebar__net-amount {
    font-size: 2rem;
    font-weight: 900;
    line-height: 1;
  }

  .pl-sidebar__net-compare {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.65rem;
    margin-top: 1.1rem;
    padding-top: 0.8rem;
    border-top: 1px solid rgba(255, 255, 255, 0.22);
    font-size: 0.85rem;
    font-weight: 800;
  }

  .pl-sidebar__tax-credit-strip {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.65rem;
    padding: 0.65rem 1.15rem;
    background: var(--pl-surface-alt);
  }

  .pl-sidebar__rows--has-tax-credit > .pl-sidebar__row:last-child {
    border-bottom: none;
  }

  .pl-sidebar__tax-credit-label {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--pl-text-muted);
    line-height: 1.3;
  }

  .pl-sidebar__tax-credit-info {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    cursor: help;
    color: var(--pl-chev);
    font-size: 0.75rem;
    line-height: 1;
    transition: color 0.15s ease;
  }

  .pl-sidebar__tax-credit-info:hover {
    color: var(--pl-text);
  }

  @media (max-width: 991.99px) {
  .cus-product-list .card-xxl-stretch {
      border: none !important;
      background: transparent;
      box-shadow: none !important;
  }
  .cus-product-list .card-body {
    padding: 0 !important;
  }
  .cus-product-list .card-header {
    padding: 0 !important;
    border-bottom: none !important;
  }
  .cus-product-list .card-body .card-body {
    padding: 10px !important;
  }
  .cus-product-list .card-body .pagi-card {
        margin-top: 5px !important;
        background: transparent;
        box-shadow: none !important;
  }
   .cus-product-list .card-body .pagi-card .ant-pagination {
      justify-content: center;
  }     
  .cus-product-list .mobile-view-container {
    .card{
      border: none !important;
      margin-bottom: 5px !important;
      box-shadow: none !important;
    }
  }

  .cus-order-list .card {
    border: none !important;
    margin-bottom: 5px !important;
    box-shadow: none !important;
  }
  .cus-order-list .card-body .pagi-card {
    margin-top: 5px !important;
  }
}
  `;

/** Top toolbar: search, pill presets, compare, marketplace, live status */
export const DashFilterBarRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 1rem;


  .df-search {
    min-width: 200px;
    max-width: 375px;
    flex: 1 1 200px;
  }

  .df-search .ant-select-selector {
    // border-radius: 999px !important;
    padding-inline: 12px !important;
  }

  --df-pill-bg: var(--app-surface-alt);
  --df-pill-color: var(--app-text);
  --df-pill-border: var(--app-border);
  --df-pill-hover-bg: var(--app-surface);
  --df-pill-primary-bg: #181c32;
  --df-pill-primary-color: #ffffff;
  --df-pill-primary-border: #181c32;
  --df-pill-compare-bg: #fff5f5;
  --df-pill-compare-color: #f1416c;
  --df-pill-compare-border: #f1416c;
  --df-pill-divider: var(--app-border);

  [data-bs-theme="dark"] & {
    --df-pill-bg: #2b2b40;
    --df-pill-color: var(--app-text-muted);
    --df-pill-border: #3f4254;
    --df-pill-hover-bg: #323248;
    --df-pill-primary-bg: #f45b68;
    --df-pill-primary-color: #ffffff;
    --df-pill-primary-border: #f45b68;
    --df-pill-compare-bg: rgba(244, 91, 104, 0.2);
    --df-pill-compare-color: #ff8a94;
    --df-pill-compare-border: #f45b68;
  }

  .df-pills {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.35rem;
  }

  .df-pill {
    border: 1px solid var(--df-pill-border);
    background: var(--df-pill-bg);
    color: var(--df-pill-color);
    font-size: 11px;
    font-weight: 600;
    padding: 0.35rem 0.75rem;
    border-radius: 5px;
    line-height: 1.25;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
    white-space: nowrap;
  }

  .df-pill:hover:not(:disabled):not(.df-pill--primary-active):not(.df-pill--compare-active) {
    background: var(--df-pill-hover-bg);
    border-color: var(--df-pill-border);
    color: var(--app-text);
  }

  .df-pill:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .df-pill--primary-active {
    background: var(--df-pill-primary-bg) !important;
    border-color: var(--df-pill-primary-border) !important;
    color: var(--df-pill-primary-color) !important;
  }

  .df-pill--primary-active .anticon {
    color: var(--df-pill-primary-color) !important;
  }

  .df-pill--compare-active {
    background: var(--df-pill-compare-bg) !important;
    border-color: var(--df-pill-compare-border) !important;
    color: var(--df-pill-compare-color) !important;
  }

  .df-pill--compare-active .anticon {
    color: var(--df-pill-compare-color) !important;
  }

  .df-divider {
    width: 1px;
    height: 28px;
    background: var(--df-pill-divider);
    flex-shrink: 0;
  }

  .df-compare-label {
    font-size: 11px;
    font-weight: 600;
    color: var(--app-text);
    white-space: nowrap;
  }

  .df-summary {
    font-size: 11px;
    font-weight: 600;
    color: var(--app-text-muted);
    white-space: nowrap;
  }

  .df-market .ant-select-selector {
    border-radius: 0.5rem !important;
  }

  .df-live {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: #50cd89;
    white-space: nowrap;
  }

  .df-live__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #50cd89;
    box-shadow: 0 0 0 2px rgba(80, 205, 137, 0.25);
  }

  .df-live--muted {
    color: #a1a5b7;
  }

  .df-live--muted .df-live__dot {
    background: #f1bc00;
    box-shadow: 0 0 0 2px rgba(241, 188, 0, 0.25);
  }

  .df-period-modal .ant-modal-content {
    padding: 0;
    border-radius: 0.65rem;
    overflow: hidden;
  }

  .df-period-modal .ant-modal-body {
    padding: 0;
  }

  .df-period-panel {
    padding: 1.25rem 1.3rem 1.15rem;
  }

  .df-period-panel__title {
    font-size: 1.05rem;
    font-weight: 800;
    color: var(--app-text);
    margin-bottom: 1rem;
  }

  .df-period-panel__fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
    margin-bottom: 1.15rem;
  }

  .df-period-panel__field {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
  }

  .df-period-panel__label {
    font-size: 0.625rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #a1a5b7;
  }

  .df-period-panel__picker.ant-picker {
    width: 100%;
    border-radius: 0.5rem;
    border-color: #e4e6ef;
  }

  .df-period-panel__picker .ant-picker-input > input {
    font-size: 0.9rem;
    font-weight: 600;
    color: #3f4254;
  }

  .df-period-panel__actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }

  .df-custom-rp .ant-picker {
    border-radius: 0.5rem;
  }

  .df-compare-switch.ant-switch-checked {
    background: #f1416c !important;
  }
  .df-compare-switch.ant-switch.ant-switch-small {
    min-width: 35px;
    height: 21px;
  }
.df-compare-switch.ant-switch.ant-switch-small.ant-switch-checked .ant-switch-handle {
    inset-inline-start: calc(100% - 19px);
}

.df-compare-switch.ant-switch.ant-switch-small .ant-switch-handle {
    width: 15px;
    height: 15px;
}


`;


export const WrapperModal = styled.div`
  .custom-range-picker {
    // border : 1px solid #000;
    .ant-picker-input > input {
      font-size: 1rem;
      font-weight: 600;
      color: var(--app-text);
    }
    .ant-picker-input > input::placeholder {
      color: var(--app-text-muted);
      font-weight: 400;
      opacity: 0.65;
    }
    .ant-picker-active-bar{
      background: ${primaryColor};
    }
  }
  .ant-picker-outlined:hover {
      border-color: ${primaryColor};
      background-color: var(--app-surface);
  }

  .dash-card-skeleton .ant-skeleton-title,
  .dash-card-skeleton .ant-skeleton-paragraph > li,
  .dash-card-skeleton .ant-skeleton-input,
  .dash-card-skeleton .ant-skeleton-button,
  .dash-card-skeleton .ant-skeleton-image {
    border-radius: 6px;
  }

  .dash-card-skeleton--metric {
    padding-top: 0.25rem;
  }

  [data-bs-theme="dark"] & .dash-card-skeleton--pl {
    .border-top,
    .border-gray-200 {
      border-color: var(--app-border) !important;
    }
  }
`;